import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row mb-10" }
const _hoisted_4 = { class: "col-12 d-flex justify-content-end" }
const _hoisted_5 = { class: "form-group radio-group-right" }
const _hoisted_6 = { class: "d-flex align-items-center gap-15" }
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = { class: "form-check" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "col-md-3 col-sm-12 col-xm-12 col-xl-3 col-lg-3"
}
const _hoisted_11 = { class: "upload-container" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "text-center"
}
const _hoisted_14 = { class: "col-md-9 col-sm-12 col-xm-12 col-xl-9 col-lg-9" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" }
const _hoisted_17 = { class: "form-group mb-5 mb-sm-10 mb-md-10" }
const _hoisted_18 = {
  key: 0,
  class: "d-block text-black fw-semibold mb-10"
}
const _hoisted_19 = {
  key: 1,
  class: "d-block text-black fw-semibold mb-10"
}
const _hoisted_20 = { class: "col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" }
const _hoisted_21 = { class: "form-group mb-5 mb-sm-10 mb-md-10" }
const _hoisted_22 = {
  key: 0,
  class: "d-block text-black fw-semibold mb-10"
}
const _hoisted_23 = {
  key: 1,
  class: "d-block text-black fw-semibold mb-10"
}
const _hoisted_24 = {
  key: 0,
  class: "col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6"
}
const _hoisted_25 = { class: "form-group mb-5 mb-sm-10 mb-md-10" }
const _hoisted_26 = {
  key: 1,
  class: "col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6"
}
const _hoisted_27 = { class: "form-group mb-sm-10 mb-md-10" }
const _hoisted_28 = {
  key: 2,
  class: "col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6"
}
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_31 = { class: "col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" }
const _hoisted_32 = { class: "form-group mb-sm-10 mb-md-10" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = {
  key: 0,
  class: "col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6 mb-2"
}
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = {
  key: 1,
  class: "col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6 mb-2"
}
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "col-md-12 col-sm-12 col-xm-12 col-xl-12 col-lg-12 mb-2" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "col-md-4 col-sm-4 col-xm-4 col-xl-4 col-lg-4" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = {
  key: 2,
  class: "col-md-4 col-sm-4 col-xm-4 col-xl-4 col-lg-4 mb-2"
}
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "col-md-4 col-sm-12 col-xm-12 col-xl-4 col-lg-4" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = {
  key: 3,
  class: "col-md-4 col-sm-4 col-xm-4 col-xl-4 col-lg-4"
}
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = {
  key: 4,
  class: "col-md-8 col-sm-8 col-xm-8 col-xl-8 col-lg-8 mb-2"
}
const _hoisted_49 = { class: "form-group mb-5 mb-sm-10 mb-md-10" }
const _hoisted_50 = {
  key: 5,
  class: "col-md-4 col-sm-12 col-xm-12 col-xl-4 col-lg-4"
}
const _hoisted_51 = { class: "form-group mb-sm-10 mb-md-10" }
const _hoisted_52 = {
  key: 6,
  class: "col-md-4 col-sm-12 col-xm-12 col-xl-4 col-lg-4"
}
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_55 = { class: "col-md-4 col-sm-12 col-xm-12 col-xl-4 col-lg-4" }
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = { class: "row mt-3" }
const _hoisted_58 = { class: "col-md-12" }
const _hoisted_59 = { class: "product-upload mb-10" }
const _hoisted_60 = { class: "dz-message needsclick" }
const _hoisted_61 = {
  key: 0,
  class: "default-image-container"
}
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "col-md-12 mt-1" }
const _hoisted_64 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_DropZone = _resolveComponent("DropZone")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addUsager,
        "validation-schema": _ctx.usagerSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Field, {
                      name: "statutUsager",
                      type: "radio",
                      value: "Personne physique",
                      id: "personne-physique",
                      class: "form-check-input",
                      modelValue: _ctx.typeDefault,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeDefault) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[7] || (_cache[7] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "personne-physique"
                    }, " Personne physique ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Field, {
                      name: "statutUsager",
                      type: "radio",
                      value: "Personne morale",
                      id: "personne-morale",
                      class: "form-check-input",
                      modelValue: _ctx.typeDefault,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.typeDefault) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[8] || (_cache[8] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "personne-morale"
                    }, " Personne morale ", -1))
                  ])
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "statutUsager",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.showType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("input", {
                      type: "file",
                      name: "urlImage",
                      ref: "fileInput",
                      onChange: _cache[2] || (_cache[2] = (event) => _ctx.onFilePrinChange(event)),
                      accept: "image/*",
                      hidden: ""
                    }, null, 544),
                    _createElementVNode("div", {
                      class: "preview-card",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                    }, [
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.imagePreview,
                            alt: "Image preview"
                          }, null, 8, _hoisted_12))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[9] || (_cache[9] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("i", { class: "flaticon-camera fs-1" })
                            ], -1),
                            _createTextVNode(" Cliquez pour ajouter l'image ")
                          ]))),
                      (_ctx.imagePreview)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "delete-btn",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeImage && _ctx.removeImage(...args)), ["stop"]))
                          }, _cache[10] || (_cache[10] = [
                            _createElementVNode("i", { class: "flaticon-close" }, null, -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.showType)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_18, _cache[11] || (_cache[11] = [
                          _createTextVNode(" Nom "),
                          _createElementVNode("span", { class: "text-danger" }, "*", -1)
                        ])))
                      : (_openBlock(), _createElementBlock("label", _hoisted_19, _cache[12] || (_cache[12] = [
                          _createTextVNode(" Nom Gérant "),
                          _createElementVNode("span", { class: "text-danger" }, "*", -1)
                        ]))),
                    _createVNode(_component_Field, {
                      name: "nom",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le nom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "nom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    (_ctx.showType)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_22, _cache[13] || (_cache[13] = [
                          _createTextVNode(" Prénom "),
                          _createElementVNode("span", { class: "text-danger" }, "*", -1)
                        ])))
                      : (_openBlock(), _createElementBlock("label", _hoisted_23, _cache[14] || (_cache[14] = [
                          _createTextVNode(" Prénom Gérant "),
                          _createElementVNode("span", { class: "text-danger" }, "*", -1)
                        ]))),
                    _createVNode(_component_Field, {
                      name: "prenom",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le prenom"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "prenom",
                      class: "text-danger"
                    })
                  ])
                ]),
                (_ctx.showType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Adresse ", -1)),
                        _createVNode(_component_Field, {
                          name: "adresse",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer l'adresse"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "adresse",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Email ", -1)),
                        _createVNode(_component_Field, {
                          name: "email",
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "Entrer l'email"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "email",
                          class: "text-danger"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.showType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Téléphone ", -1)),
                        _createVNode(_component_Field, {
                          name: "numtel",
                          modelValue: _ctx.telephone,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telephone) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_vue_tel_input, _mergeProps({
                              placeholder: "Entrer le numéro de téléphone",
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, {
                              defaultCountry: "BJ",
                              mode: "international",
                              onValidate: _ctx.validate,
                              class: "shadow-none fs-md-15 text-black py-2"
                            }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "numtel",
                          class: "text-danger"
                        }),
                        (!_ctx.validPhone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, "Veuillez entrer un numéro correcte"))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de naissance ", -1)),
                    _createVNode(_component_Field, {
                      name: "dateNais",
                      type: "date",
                      class: "form-control shadow-none fs-md-15 text-black"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "dateNais",
                      class: "text-danger"
                    })
                  ])
                ], 512), [
                  [_vShow, _ctx.showType]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              (_ctx.showType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " IFU ", -1)),
                      _createVNode(_component_Field, {
                        name: "ifu",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer un ifu"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "ifu",
                        class: "text-danger"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.showType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " NPI ", -1)),
                      _createVNode(_component_Field, {
                        name: "npi",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer un npi"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "npi",
                        class: "text-danger"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                    _createTextVNode(" Raison sociale "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "raisonSocial",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer la raison sociale"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "raisonSocial",
                    class: "text-danger"
                  })
                ])
              ], 512), [
                [_vShow, !_ctx.showType]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Sigle ", -1)),
                  _createVNode(_component_Field, {
                    name: "sigle",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le sigle"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "sigle",
                    class: "text-danger"
                  })
                ])
              ], 512), [
                [_vShow, !_ctx.showType]
              ]),
              (!_ctx.showType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " IFU ", -1)),
                      _createVNode(_component_Field, {
                        name: "ifu",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer un ifu"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "ifu",
                        class: "text-danger"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                    _createTextVNode(" Régistre de commerce "),
                    _createElementVNode("span", { class: "text-danger" }, "*")
                  ], -1)),
                  _createVNode(_component_Field, {
                    name: "rccm",
                    type: "text",
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Entrer le régistre de commerce"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "rccm",
                    class: "text-danger"
                  })
                ])
              ], 512), [
                [_vShow, !_ctx.showType]
              ]),
              (!_ctx.showType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " NPI ", -1)),
                      _createVNode(_component_Field, {
                        name: "npi",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer un npi"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "npi",
                        class: "text-danger"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _cache[26] || (_cache[26] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Adresse ", -1)),
                      _createVNode(_component_Field, {
                        name: "adresse",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer l'adresse"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "adresse",
                        class: "text-danger"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _cache[27] || (_cache[27] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Email ", -1)),
                      _createVNode(_component_Field, {
                        name: "email",
                        type: "text",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Entrer l'email"
                      }),
                      _createVNode(_component_ErrorMessage, {
                        name: "email",
                        class: "text-danger"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.showType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Téléphone ", -1)),
                      _createVNode(_component_Field, {
                        name: "numtel",
                        modelValue: _ctx.telephone,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.telephone) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_vue_tel_input, _mergeProps({
                            placeholder: "Entrer le numéro de téléphone",
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            defaultCountry: "BJ",
                            mode: "international",
                            onValidate: _ctx.validate,
                            class: "shadow-none fs-md-15 text-black py-2"
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "onValidate"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "numtel",
                        class: "text-danger"
                      }),
                      (!_ctx.validPhone)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, "Veuillez entrer un numéro correcte"))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_55, [
                _createElementVNode("div", _hoisted_56, [
                  _cache[29] || (_cache[29] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de création ", -1)),
                  _createVNode(_component_Field, {
                    name: "dateCreation",
                    type: "date",
                    class: "form-control shadow-none fs-md-15 text-black"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "dateCreation",
                    class: "text-danger"
                  })
                ])
              ], 512), [
                [_vShow, !_ctx.showType]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_DropZone, {
                    name: "fichiers[]",
                    maxFilesize: 50000000,
                    maxFiles: Number(10000000000),
                    class: "",
                    uploadOnDrop: true,
                    onAddedFile: _ctx.onFileAdd,
                    onRemovedFile: _ctx.onFileRemove,
                    options: _ctx.dropzoneOptions,
                    onVdropzoneSuccess: _ctx.onSuccess,
                    onVdropzoneError: _ctx.onError
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.hasFiles)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createElementVNode("img", {
                              src: _ctx.defaultImage,
                              alt: "Default",
                              class: "default-image"
                            }, null, 8, _hoisted_62),
                            _cache[30] || (_cache[30] = _createElementVNode("p", null, "Glissez et dépossez ici", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["maxFiles", "onAddedFile", "onRemovedFile", "options", "onVdropzoneSuccess", "onVdropzoneError"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _cache[32] || (_cache[32] = _createElementVNode("button", {
                  class: "btn btn-success me-3",
                  type: "submit"
                }, " Ajouter un marchand ", -1)),
                _createVNode(_component_router_link, {
                  to: "/liste-usager",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}